import myApi from "@/plugins/axios";

/**
 * @param {Function} executeRecaptcha - función executeRecaptcha del composable
 * @param {string} action - acción recaptcha (ej: "ecommerce-register")
 * @param {string} url - endpoint API (ej: "ecommerce/register")
 * @param {Object} data - payload a enviar en el body
 */
export async function recaptchaPost(executeRecaptcha, action, url, data = {}) {
  if (!executeRecaptcha) {
    throw new Error("executeRecaptcha no está disponible, ¿olvidaste pasarlo como parámetro?");
  }
  
  try {
    const token = await executeRecaptcha(action);
   
    return await myApi.post(url, data, {
      headers: {
        "X-Recaptcha-Token": token,
        "X-Recaptcha-Action": action,
      },
    });
  } catch (error) {
    console.error('Error en recaptchaPost:', error);
    throw error;

  }
}